/**
 * AuthShell — centered card layout used by login / signup / reset pages.
 *
 * Kept separate from ``Layout`` because the auth screens shouldn't show
 * the sidebar (the user isn't authenticated yet) and we want a different
 * vertical balance.
 */
import { ReactNode } from "react";
import { supabaseConfigured } from "../auth/supabase";

export default function AuthShell({
  title,
  children,
}: {
  title: string;
  children: ReactNode;
}) {
  return (
    <div className="min-h-full flex items-center justify-center bg-slate-50 px-4">
      <div className="w-full max-w-sm">
        <div className="text-center mb-6">
          <div className="text-lg font-semibold text-slate-900">PBMC Platform</div>
          <div className="text-xs text-slate-500 mt-0.5">scRNA-seq + AI</div>
        </div>
        <div className="card p-6">
          <h1 className="text-base font-semibold text-slate-900 mb-4">{title}</h1>
          {!supabaseConfigured && (
            <div className="mb-4 text-xs text-amber-800 bg-amber-50 border border-amber-200 rounded-md px-3 py-2">
              <strong>Supabase not configured.</strong> The deployer hasn't set
              <code className="mx-1">VITE_SUPABASE_URL</code> /
              <code className="mx-1">VITE_SUPABASE_ANON_KEY</code>. Auth requests
              will fail until that's fixed.
            </div>
          )}
          {children}
        </div>
      </div>
    </div>
  );
}
